<template>
  <div class="member-addr" v-if="user">
    <section class="row gx-5">
      <div class="loft-col col-md-5 pt-5 pb-5">
        <div class="title mb-3 ps-3 pe-3">地址</div>
        <div class="mb-3 content border border-dark p-3" v-for="(addr, index) in addrs" :key="index">
          <div>{{ addr.consignee || user.alias }} <span v-if="user.addressId === addr.addressId">(預設收貨地址)</span></div>
          <div>{{ addr.address }}</div>
          <div>{{ addr.zipcode }}{{ getRegionName(addr.city) }}{{ getRegionName(addr.district) }}</div>
          <div class="row align-items-end">
            <div class="col">
              <div>{{ getRegionName(addr.country) }}</div>
              <div>{{ addr.mobile }}</div>
            </div>
            <div class="col-auto">
              <button class="btn btn-sm btn-dark ps-3 pe-3 rounded-0" @click="onEditClicked(addr)">編輯</button>
              <button class="btn btn-sm btn-secondary ps-3 pe-3 rounded-0" @click="onDelClicked(addr)" :disabled="addrs.length <= 1">刪除</button>
            </div>
          </div>
        </div>
      </div>
      <div class="loft-col col-md-7 pt-5 pb-5">
        <div class="title mb-3">新增/修改地址</div>
        <div class="row gx-2 mb-2">
          <div class="col-6">
            <div class="form-floating">
              <input id="input-last-name" type="text" class="form-control" placeholder="姓氏" v-model="username.last">
              <label for="input-last-name" class="text-secondary">姓氏</label>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating">
              <input id="input-first-name" type="text" class="form-control" :class="validation.firstName.class" placeholder="名字" v-model="username.first">
              <label for="input-first-name" class="text-secondary">名字</label>
              <div class="invalid-feedback">{{ validation.firstName.feedback }}</div>
            </div>
          </div>
        </div>
        <div class="form-floating mb-2">
          <input id="input-company" type="text" class="form-control" placeholder="公司行號" v-model="addr.addressName">
          <label for="input-company" class="text-secondary">公司行號（選填）</label>
        </div>
        <div class="row gx-2 mb-2">
          <div class="col-6">
            <div class="form-floating">
              <select id="input-country" class="form-select" placeholder="國家" v-model="addr.country">
                <option value="0" disabled>請選擇...</option>
                <template v-for="(item, index) in countryOptions">
                  <option :key="`country-${index}`" :value="item.regionId">{{ item.regionName }}</option>
                </template>
              </select>
              <label for="input-country" class="text-secondary">國家</label>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating">
              <select id="input-city" class="form-select" :class="validation.city.class" placeholder="城市" v-model="addr.city">
                <option value="0" disabled>請選擇...</option>
                <template v-for="(item, index) in cityOptions">
                  <option :key="`city-${index}`" :value="item.regionId">{{ item.regionName }}</option>
                </template>
              </select>
              <label for="input-city" class="text-secondary">城市</label>
              <div class="invalid-feedback">{{ validation.city.feedback }}</div>
            </div>
          </div>
        </div>
        <div class="row gx-2 mb-2">
          <div class="col-6">
            <div class="form-floating">
              <select id="input-area" class="form-select" :class="validation.district.class" placeholder="鄉鎮市區" v-model="addr.district">
                <option value="0" disabled>請選擇...</option>
                <template v-for="(item, index) in districtOptions">
                  <!-- 必須用 v-if 而非 v-show：Safari 的原生 select 下拉不會套用 option 的 display:none -->
                  <option v-if="!addr.city || item.parentId === addr.city" :key="`dist-${index}`" :value="item.regionId">{{ item.regionName }}</option>
                </template>
              </select>
              <label for="input-area" class="text-secondary">鄉鎮市區</label>
              <div class="invalid-feedback">{{ validation.district.feedback }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating">
              <input id="input-postal-code" type="number" class="form-control" placeholder="郵遞區號" v-model="addr.zipcode">
              <label for="input-postal-code" class="text-secondary">郵遞區號</label>
            </div>
          </div>
        </div>
        <div class="form-floating mb-2">
          <input id="input-addr" type="text" class="form-control" :class="validation.address.class" placeholder="請輸入地址" maxlength="128" v-model="addr.address">
          <label for="input-addr" class="text-secondary">請輸入地址</label>
          <div class="invalid-feedback">{{ validation.address.feedback }}</div>
        </div>
        <div class="row gx-2 mb-2">
          <div class="col-6">
            <div class="form-floating">
              <input id="input-email" type="email" class="form-control" :class="validation.email.class" placeholder="E-mail" v-model="addr.email">
              <label for="input-email" class="text-secondary">E-mail</label>
              <div class="invalid-feedback">{{ validation.email.feedback }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating">
              <input id="input-phone" type="phone" class="form-control" :class="validation.mobile.class" placeholder="電話" v-model="addr.mobile">
              <label for="input-phone" class="text-secondary">電話</label>
              <div class="invalid-feedback">{{ validation.mobile.feedback }}</div>
            </div>
          </div>
        </div>
        <div class="form-check mt-3">
          <input id="check-def-addr" type="checkbox" name="payment-addr" class="form-check-input loft-check-input" v-model="isDefault">
          <label for="check-def-addr" class="form-check-label">將此地址設為預設地址</label>
        </div>
        <button class="btn btn-dark w-50 mt-5" @click="onSubmitClicked">送出</button>
      </div>
    </section>
  </div>
</template>

<script>
import zipcode from '@/taiwan-zip-code.json'
import constant from '@/constant.js'
import userApi from '@/api/user.js'
import { mapGetters, mapMutations } from 'vuex'

function Addr () {
  this.addressId = null
  this.userId = null
  this.firstName = ''
  this.lastName = ''
  this.addressName = ''
  this.consignee = null
  this.email = null
  this.country = 1
  this.province = 0
  this.city = 0
  this.district = 0
  this.address = null
  this.zipcode = null
  this.mobile = null
}
function Username () {
  this.first = ''
  this.last = ''
}

export default {
  name: 'MemberAddr',
  data: function () {
    return {
      addrs: [],
      addr: new Addr(),
      username: new Username(),
      isDefault: false,
      isValidated: false,
      validation: {
        firstName: { class: null, feedback: null },
        email: { class: null, feedback: null },
        mobile: { class: null, feedback: null },
        city: { class: null, feedback: null },
        district: { class: null, feedback: null },
        address: { class: null, feedback: null }
      }
    }
  },
  computed: {
    ...mapGetters([
      'authId',
      'user',
      'regions',
      'getRegion',
      'getRegionName'
    ]),
    countryOptions: function () {
      var ret = []
      if (this.regions) {
        this.regions.forEach(e => {
          if (e.parentId === 0) {
            ret.push(e)
          }
        })
      }
      return ret
    },
    provinceOptions: function () {
      var ret = []
      if (this.regions && this.countryOptions) {
        this.regions.forEach(region => {
          this.countryOptions.forEach(country => {
            if (region.parentId === country.regionId) {
              ret.push(region)
            }
          })
        })
      }
      return ret
    },
    cityOptions: function () {
      var ret = []
      if (this.regions && this.provinceOptions) {
        this.regions.forEach(region => {
          this.provinceOptions.forEach(province => {
            if (region.parentId === province.regionId) {
              ret.push(region)
            }
          })
        })
      }
      return ret
    },
    districtOptions: function () {
      var ret = []
      if (this.regions && this.cityOptions) {
        this.regions.forEach(region => {
          this.cityOptions.forEach(city => {
            if (region.parentId === city.regionId) {
              ret.push(region)
            }
          })
        })
      }
      return ret
    }
  },
  watch: {
    'addr.district': function (value) {
      this.validation.city.class = null
      this.validation.district.class = null
      // auto select city
      if (!value) {
        return
      }
      var city = this.cityOptions.find(e => e.regionId === this.getRegion(value).parentId)
      if (city) {
        this.addr.city = city.regionId
      }
      // get zipcode
      this.getZipcode()
    },
    'addr.city': function (value) {
      this.validation.city.class = null
      this.validation.district.class = null
      if (!value) {
        return
      }
      // clear district if it isn't in the city
      if (this.addr.district && this.getRegion(this.addr.district).parentId !== value) {
        this.addr.district = 0
      }
      // update province
      var city = this.getRegion(value)
      if (city) {
        this.addr.province = city.parentId
      }
      // get zipcode
      this.getZipcode()
    },
    'addr.address': function (value) {
      this.validation.address.class = null
    },
    'addr.email': function (value) {
      this.validation.email.class = null
    },
    'addr.mobile': function (value) {
      this.validation.mobile.class = null
    },
    'username.first': function (value) {
      this.validation.firstName.class = null
    }
  },
  mounted: function () {
    this.apiGetAddrs()
  },
  methods: {
    ...mapMutations([
      'setAlert',
      'signOut',
      'setUser'
    ]),
    apiGetAddrs: function () {
      var self = this
      userApi.getAddrs(this.authId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.addrs = rspData

        // manually update default addr
        if (self.isDefault) {
          var defAddr = self.addrs.find(e => (e.address === self.addr.address && e.district === self.addr.district))
          if (defAddr) {
            self.apiSetDefAddr(defAddr)
          }
        }
        self.addr = new Addr()
        self.username = new Username()
        if (self.user) {
          self.username.first = self.user.firstName
          self.username.last = self.user.lastName
          self.addr.email = self.user.email
        }

        // auto select default if no addresses
        if (!self.addrs || self.addrs.length === 0) {
          self.isDefault = true
        }
      })
    },
    apiSetAddr: function () {
      var self = this
      var api = null

      // build data
      this.addr.lastName = `${this.username.last}`.trim()
      this.addr.firstName = `${this.username.first}`.trim()
      this.addr.consignee = `${this.username.last} ${this.username.first}`.trim()
      this.addr.userId = this.user.userId
      // this.addr.email = this.user.email
      this.addr.province = this.getRegion(this.addr.city).parentId

      // call api
      api = this.addr.addressId ? userApi.setAddr : userApi.addAddr
      api(this.addr, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: `執行發生錯誤：${rspData} (${err})` })
          }
          return
        }
        self.setAlert({ type: constant.ALERT_TYPE.INFO, msg: '設定完成' })
        self.apiGetAddrs()
      })
    },
    apiDelAddr: function (addressId) {
      var self = this
      userApi.delAddr(addressId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: `執行發生錯誤：${rspData} (${err})` })
          }
          return
        }
        // process default addr
        if (self.user.addressId === addressId && self.addrs.length) {
          var defAddr = self.addrs.find(e => e.addressId !== addressId)
          if (defAddr) {
            self.apiSetDefAddr(defAddr)
          }
        }
        self.setAlert({ type: constant.ALERT_TYPE.INFO, msg: '已刪除' })
        self.apiGetAddrs()
      })
    },
    apiSetDefAddr: function (addr) {
      var self = this
      userApi.setDefAddr(addr, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.apiGetUser()
      })
    },
    apiGetUser: function () {
      var self = this
      userApi.getUser(this.authId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.setUser(rspData)
      })
    },
    getZipcode: function () {
      var city = zipcode.cities.find(e => e.name === this.getRegionName(this.addr.city))
      if (!city) {
        return
      }
      var dist = city.region.find(e => e.name === this.getRegionName(this.addr.district))
      this.addr.zipcode = dist ? dist.code : city.code
    },
    onEditClicked: function (addr) {
      if (!addr) {
        return
      }
      this.addr = Object.assign({}, addr)
      if (this.addr.consignee) {
        if (this.addr.lastName) {
          if (!this.addr.consignee) {
            this.username.first = this.user.firstName
            this.username.last = this.user.lastName
          } else {
            this.username.first = this.addr.firstName
            this.username.last = this.addr.lastName
          }
        } else {
          this.username.first = this.addr.consignee
        }
      } else {
        this.username.first = this.user.firstName || this.user.alias
        this.username.last = this.user.lastName
      }
      this.isDefault = (addr.addressId === this.user.addressId)
    },
    onDelClicked: function (addr) {
      if (!addr || !confirm('刪除地址' + addr.addressName + '？')) {
        return
      }
      this.apiDelAddr(addr.addressId)
    },
    onSubmitClicked: function () {
      // input check
      this.isValidated = true
      // check name
      if (!this.username.first) {
        this.isValidated = false
        this.validation.firstName.class = 'is-invalid'
        this.validation.firstName.feedback = '請輸入收件人'
      } else {
        this.validation.firstName.class = null
      }
      // check email
      if (!this.addr.email) {
        this.isValidated = false
        this.validation.email.class = 'is-invalid'
        this.validation.email.feedback = '請輸入聯絡E-mail'
      } else if (!this.addr.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
        this.isValidated = false
        this.validation.email.class = 'is-invalid'
        this.validation.email.feedback = '不正確的E-mail格式'
      } else {
        this.validation.email.class = null
      }
      // check mobile
      if (!this.addr.mobile) {
        this.isValidated = false
        this.validation.mobile.class = 'is-invalid'
        this.validation.mobile.feedback = '請輸入聯絡電話'
      } else {
        this.validation.mobile.class = null
      }
      // check city
      if (!this.addr.city) {
        this.isValidated = false
        this.validation.city.class = 'is-invalid'
        this.validation.city.feedback = '請選擇城市'
      } else {
        this.validation.city.class = null
      }
      // check district
      if (!this.addr.district && (this.addr.city && this.addr.city !== 9 && this.addr.city !== 17)) {
        this.isValidated = false
        this.validation.district.class = 'is-invalid'
        this.validation.district.feedback = '請選擇鄉鎮市區'
      } else {
        this.validation.district.class = null
      }
      // check address
      if (!this.addr.address) {
        this.isValidated = false
        this.validation.address.class = 'is-invalid'
        this.validation.address.feedback = '請輸入地址'
      } else {
        this.validation.address.class = null
      }

      if (!this.isValidated) {
        return
      }

      this.apiSetAddr()
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 1.3rem;
  font-weight: 500;
}
.content {
  font-weight: 500;
}
@media screen and (min-width: 768px) {
  .member-addr .loft-col:last-child {
    border-left: 1px solid;
    border-color: var(--bs-secondary);
  }
}
</style>
